jQuery(function ($) {
    // Use global shared function from main.js if available, otherwise fallback to local
    const loadValidationScript = window.loadValidationScript || function(callback) {
        if (window.InputValidator) {
            if (typeof callback === 'function') callback();
        } else if (window._validationScriptLoading) {
            const checkInterval = setInterval(function() {
                if (window.InputValidator) {
                    clearInterval(checkInterval);
                    delete window._validationScriptLoading;
                    if (typeof callback === 'function') callback();
                }
            }, 50);
        } else {
            window._validationScriptLoading = true;
            $.getScript("/assets/frontend/js/validation.js", function() {
                delete window._validationScriptLoading;
                if (typeof callback === 'function') callback();
            });
        }
    };
    
    loadValidationScript(function () {
        const authParent = $("body");

        // AUTH FORM
        let authFormRunner = true;

        authParent.on("submit", ".auth-form", function (e) {
            e.preventDefault();


            if (authFormRunner === true) {
                authFormRunner = false;

                let authForm = $(this);
                let authPreloader = authForm.find(".auth-form-preloader");
                let authFormInfo = authForm.serializeArray().reduce(function(obj, item) {
                    obj[item.name] = item.value;
                    return obj;
                }, {});

                let warningBoxAuth = authForm.find(".auth-warning-messages");
                let inputAuthEmail = authForm.find(".auth-input-warning-email");
                let messageAuthEmail = authForm.find(".auth-message-warning-email");
                let inputAuthPassword = authForm.find(".auth-input-warning-password");
                let messageAuthPassword = authForm.find(".auth-message-warning-password");

                // Show preloader
                authPreloader.addClass("preloader-visible");

                // Inject CSRF token
                authFormInfo = window.CSRFHelper.injectCSRF(authFormInfo);

                $.ajax({
                    url: "/profile/login", // Adjust as needed
                    type: "post",
                    data: authFormInfo,
                    dataType: 'json',
                    success: function (response) {
                        // Update CSRF token if provided
                        window.CSRFHelper.updateCSRFMeta(response);
                        
                        authFormRunner = true;
                        authPreloader.removeClass("preloader-visible");

                        // Clear previous states
                        messageAuthEmail.hide();
                        messageAuthPassword.hide();
                        warningBoxAuth.hide();

                        if (response.success === false) {
                            let authFormChecker = 0;

                            // Email validation
                            if (response.errors?.email) {
                                messageAuthEmail.text(response.errors.email).show();
                                inputAuthEmail.addClass('is-invalid');
                                authFormChecker++;
                            } else {
                                inputAuthEmail.removeClass('is-invalid');
                            }

                            // Password validation
                            if (response.errors?.password) {
                                messageAuthPassword.text(response.errors.password).show();
                                inputAuthPassword.addClass('is-invalid');
                                authFormChecker++;
                            } else {
                                inputAuthPassword.removeClass('is-invalid');
                            }

                            // Generic login error
                            if (authFormChecker === 0 && response.message) {
                                messageAuthEmail.text(response.message).show();
                                inputAuthEmail.addClass('is-invalid');
                                authFormChecker++;
                            }

                            if (authFormChecker > 0) {
                                warningBoxAuth.show();
                            }

                        } else {
                            if (response.redirect) {
                                var email = (authFormInfo["form-auth-email"] || "").trim();
                                if (email && window.CarbuyPasskeyLogin && typeof window.CarbuyPasskeyLogin.saveLastEmail === "function") {
                                    window.CarbuyPasskeyLogin.saveLastEmail(email);
                                } else if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                                    try { localStorage.setItem("carbuy_last_login_email", email); } catch (e) {}
                                }
                                window.location.href = response.redirect;
                            }
                        }
                    },
                    error: function () {
                        authFormRunner = true;
                        authPreloader.removeClass("preloader-visible");
                        warningBoxAuth.show().text("Nezināma kļūda. Lūdzu, mēģiniet vēlreiz.");
                    }
                });
            }
        });
        // END AUTH FORM


        // RESET PASSWORD FORM
        let resetPasswordForm = $(".reset-password-form");
        let resetPasswordPreloader = $(".reset-password-form-preloader");
        let warningBoxResetPassword = $(".reset-password-warning-messages");
        let inputResetPasswordEmail = $(".reset-password-input-warning-email");
        let messageResetPasswordEmail = $(".reset-password-message-warning-email");
        let resetPasswordFormRunner = true;
        authParent.on("submit", ".reset-password-form", function (e) {
            // Check if this is a password reset form (has password fields) or forgot password form (has email field)
            const hasPasswordField = $(this).find('input[name="form-reset-password"]').length > 0;
            const hasEmailField = $(this).find('input[name="form-reset-password-email"]').length > 0;

            if (hasPasswordField) {
                // This is a password reset form (with password fields), don't interfere
                // The password-reset.js handler will handle it
                e.stopImmediatePropagation(); // Stop this handler and prevent other handlers
                return false; // Don't prevent default, let password-reset.js handle it
            }
            
            if (!hasEmailField) {
                // Neither password nor email field, don't handle
                return true;
            }

            // This is a forgot password form, handle it normally
            e.preventDefault();
            if (resetPasswordFormRunner === true) {
                resetPasswordFormRunner = false;
                let resetPasswordFormInfo = resetPasswordForm.serializeArray().reduce(function(obj, item) {
                    obj[item.name] = item.value;
                    return obj;
                }, {});

                // Client-side validation
                let validationErrors = {};
                const email = resetPasswordFormInfo['form-reset-password-email'] || '';

                if (!email.trim()) {
                    validationErrors.email = 'E-pasts ir obligāts.';
                } else if (!window.InputValidator.validateEmail(email)) {
                    validationErrors.email = 'Lūdzu, ievadiet derīgu e-pasta adresi.';
                }

                if (Object.keys(validationErrors).length > 0) {
                    resetPasswordFormRunner = true;
                    messageResetPasswordEmail.text(validationErrors.email).show();
                    inputResetPasswordEmail.addClass('is-invalid');
                    warningBoxResetPassword.show();
                    return;
                }

                resetPasswordPreloader.addClass("preloader-visible");

                // Inject CSRF token
                resetPasswordFormInfo = window.CSRFHelper.injectCSRF(resetPasswordFormInfo);

                $.ajax({
                    url: "/profile/forgot",
                    type: "post",
                    data: resetPasswordFormInfo,
                    dataType: 'json',
                    success: function (response) {
                        // Update CSRF token if provided
                        window.CSRFHelper.updateCSRFMeta(response);

                        resetPasswordFormRunner = true;
                        resetPasswordPreloader.removeClass("preloader-visible");

                        // Clear previous states
                        messageResetPasswordEmail.hide();
                        warningBoxResetPassword.hide();
                        inputResetPasswordEmail.removeClass('is-invalid');

                        if (response.success === false) {
                            if (response.errors?.email) {
                                messageResetPasswordEmail.text(response.errors.email).show();
                                inputResetPasswordEmail.addClass('is-invalid');
                            } else if (response.message) {
                                messageResetPasswordEmail.text(response.message).show();
                                inputResetPasswordEmail.addClass('is-invalid');
                            }
                            warningBoxResetPassword.show();
                        } else {
                            // Success - show success message and hide form
                            resetPasswordForm.siblings(".reset-password-success-submit").removeClass("d-none");
                            resetPasswordForm.remove();
                        }
                    },
                    error: function () {
                        resetPasswordFormRunner = true;
                        resetPasswordPreloader.removeClass("preloader-visible");
                        messageResetPasswordEmail.text("Nezināma kļūda. Lūdzu, mēģiniet vēlreiz.").show();
                        inputResetPasswordEmail.addClass('is-invalid');
                        warningBoxResetPassword.show();
                    }
                });
            }
        });
        // END RESET PASSWORD FORM

        // SWITCH AUTHORIZATION / RESET PASSWORD
        authParent.on("click", ".auth-reset-password-toggle", function (e) {
            e.preventDefault();
            $(".auth-form").hide()
            $(".reset-password-form").show();
        });
        authParent.on("click", ".back-to-auth-toggle", function (e) {
            e.preventDefault();
            $(".auth-form").show()
            $(".reset-password-form").hide();
        });
        // END SWITCH AUTHORIZATION / RESET PASSWORD

    });
});